export interface GetAllAuthorsModel {
    authors: AuthorsModel;
}

export interface AuthorsModel {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
    data: AuthorDataModel[];
}

export interface AuthorDataModel {
    authorId: string;
    description: string;
    designation: string;
    fullName: string;
    linkedinUrl: string;
    profilePicture: string;
}
